import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { DesignLayoutType, EventPageType } from '@graphql/generated-base';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useMemo } from 'react';
import { useEventDesignLayoutType } from './useEventDesignLayoutType/useEventDesignLayoutType';

type UseGetGuestSitePagesArgs = Readonly<{
  pages?: readonly EventPageFragment[];
  layoutType?: DesignLayoutType | null;
}>;

type UseGetGuestSitePagesReturn = Readonly<{
  pages: readonly EventPageFragment[];
}>;

// Filtering logic moved from BE to FE to avoid presentational logic on BE
export const useGetGuestSitePages = ({ pages = [], layoutType: layoutTypeProp }: UseGetGuestSitePagesArgs = {}): UseGetGuestSitePagesReturn => {
  const { eventInfo } = useEventInfo();
  const { layoutType: fetchedLayoutType } = useEventDesignLayoutType({ skip: layoutTypeProp != null });
  const layoutType = layoutTypeProp ?? fetchedLayoutType;

  const currentPages = useMemo(() => {
    if (!eventInfo) {
      return [];
    }

    const { qanda, story } = eventInfo;

    const tidbitsExist = qanda?.length && qanda.length > 0;
    const storyExists = !!story;
    let currentPages = pages;

    if (layoutType === DesignLayoutType.brannan && !tidbitsExist && !storyExists) {
      currentPages = currentPages.filter(page => page.type !== EventPageType.story);
    }

    if (layoutType === DesignLayoutType.aloha) {
      if (!tidbitsExist) {
        currentPages = currentPages.filter(page => page.type !== EventPageType.tidbits);
      }

      if (!storyExists) {
        currentPages = currentPages.filter(page => page.type !== EventPageType.story);
      }
    }

    return currentPages;
  }, [eventInfo, pages, layoutType]);

  return {
    pages: currentPages,
  };
};
